/**
 * @func isMDY
 * @param {string} value - the input of the function
 * @return {boolean}
 * @desc Checks that the input is a date string in one of these formats:
 * MM/DD/YYYY M/D/YYYY MM/DD/YY M/D/YY
 * ```js
 * isMDY('03/04/2020');
 * // returns true
 * ```
 * @memberof module:TypeCheck
 * @instance
 */
const patternMonthDayYear = /^([1-9]|0[1-9]|1[012])\/([1-9]|0[1-9]|[12][0-9]|3[01])\/\d{2,4}$/;
function isMDY(value) {
    return patternMonthDayYear.test(value);
}

export { isMDY as default };
